export enum NotificationRecurrenceFrequency {
    OnceAWeek = 'OnceAWeek',
    EveryTwoWeeks = 'EveryTwoWeeks',
    Monthly = 'Monthly',
}

export enum EmailScheduleType {
    Never = 'Never',
    OneTime = 'OneTime',
    Recurring = 'Recurring',
}
